import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  ocrOutline: {
    '& input, textarea': {
      border: theme.border,
      borderWidth: 2,
      borderColor: theme.colors.yellow,
      background: theme.yellowBackground,
      borderRadius: theme.borderRadius,
    },
  },
}))

const OCRWrapper = (props) => {
  const classes = useStyles(props)
  const {
    children,
    ocr,
    isOcrValue,
    className,
    customClass,
  } = props

  const ocrOutline = isOcrValue

  const additionalProps = {
    className: clsx(className, { [classes.ocrOutline]: ocr && ocrOutline }),
    customClass: clsx(customClass, { [classes.ocrOutline]: ocr && ocrOutline }),
  }

  return React.cloneElement(children, additionalProps)
}

OCRWrapper.propTypes = {
  valueKey: PropTypes.string,
  ocrKey: PropTypes.string,
  ocr: PropTypes.object,
  children: PropTypes.object,
  isDate: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isOcrValue: PropTypes.bool,
}

export default OCRWrapper
